import { Link } from 'react-router-dom'


const MembershipServicesSection = () => {
  const services = [
    {
      id: 1,
      title: "Aesthetics & Anti-Aging",
      description: "Tailored access to leading clinics and specialists for beauty, wellness, and rejuvenation.",
      image: "/Landing Page/Membership Services/01-Aesthetics & Anti-Aging.png",
      imageSize: { width: 416, height: 416 },
      href: "/member-services/aesthetics-anti-aging"
    },
    {
      id: 2,
      title: "Art Escrow & Consulting",
      description: "Secure transactions and expert advice for acquiring, managing, or selling fine art.",
      image: "/Landing Page/Membership Services/02-Art Escrow & Consulting.png",
      imageSize: { width: 416, height: 416 },
      href: "/member-services/art-escrow-consulting"
    },
    {
      id: 3,
      title: "Black Car Service",
      description: "Chauffeured luxury vehicles for seamless, discreet, and reliable ground transportation.",
      image: "/Landing Page/Membership Services/03-Black Car Service.png",
      imageSize: { width: 416, height: 416 },
      href: "/member-services/black-car-service"
    },
    {
      id: 4,
      title: "Education Consulting",
      description: "Personalized guidance for school placements, admissions, and academic development.",
      image: "/Landing Page/Membership Services/04-Education Consulting.png",
      imageSize: { width: 640, height: 416 },
      href: "/member-services/education-consulting"
    },
    {
      id: 5,
      title: "Invite-Only Lounge",
      description: "Exclusive access to members-only lounges for privacy, networking, and relaxation.",
      image: "/Landing Page/Membership Services/05-Invite-Only Lounge.png",
      imageSize: { width: 640, height: 416 },
      href: "/member-services/invite-only-lounge"
    },
    {
      id: 6,
      title: "Personal Travel Planner",
      description: "Curated itineraries and bookings for stress-free, bespoke travel experiences.",
      image: "/Landing Page/Membership Services/06-Personal Travel Planner.png",
      imageSize: { width: 416, height: 416 },
      href: "/member-services/personal-travel-planner"
    },
    {
      id: 7,
      title: "Private Dining",
      description: "Reservations at hidden gems and Michelin-starred restaurants with VIP treatment.",
      image: "/Landing Page/Membership Services/07-Private Dining.png",
      imageSize: { width: 416, height: 416 },
      href: "/member-services/private-dining"
    },
    {
      id: 8,
      title: "Private Jet Charter",
      description: "On-demand private aviation for flexible, secure, and comfortable global travel.",
      image: "/Landing Page/Membership Services/08-Private Jet Charter.png",
      imageSize: { width: 416, height: 416 },
      href: "/member-services/private-jet-charter"
    },
    {
      id: 9,
      title: "Ticketing & Events",
      description: "Priority access to sold-out concerts, sporting events, and VIP experiences.",
      image: "/Landing Page/Membership Services/09-Ticketing & Events.png",
      imageSize: { width: 640, height: 416 },
      href: "/member-services/ticketing-events"
    },
    {
      id: 10,
      title: "Yacht Charter",
      description: "Customized yacht experiences from day trips to extended luxury voyages.",
      image: "/Landing Page/Membership Services/10-Yacht Charter.png",
      imageSize: { width: 640, height: 416 },
      href: "/member-services/yacht-charter"
    }
  ]

  // Group services according to the specified structure
  const serviceRows = [
    services.slice(0, 3),  // Cards 1-3
    services.slice(3, 5),  // Cards 4-5
    services.slice(5, 8),  // Cards 6-8
    services.slice(8, 10)  // Cards 9-10
  ]

  return (
    <section
      className="w-full bg-white"
      style={{
        paddingLeft: 'clamp(16px, 5vw, 64px)',
        paddingRight: 'clamp(16px, 5vw, 64px)',
        paddingTop: 'clamp(32px, 8vw, 64px)',
        paddingBottom: 'clamp(32px, 8vw, 64px)',
        backgroundColor: '#FFFFFF'
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 'clamp(32px, 8vw, 64px)' }}>
        {serviceRows.map((row, rowIndex) => (
          <div
            key={rowIndex}
            className="flex flex-wrap justify-center items-start w-full"
            style={{
              gap: 'clamp(16px, 4vw, 32px)'
            }}
          >
            {row.map((service) => (
              <div
                key={service.id}
                className="flex flex-col text-left"
                style={{
                  flex: '1 1 300px',
                  minWidth: '280px',
                  maxWidth: '100%'
                }}
              >
                {/* Service Image */}
                <div style={{ marginBottom: '16px' }}>
                  <img
                    src={service.image}
                    alt={service.title}
                    width={service.imageSize.width}
                    height={service.imageSize.height}
                    style={{
                      width: '100%',
                      height: 'auto',
                      objectFit: 'cover',
                      display: 'block'
                    }}
                  />
                </div>

                {/* Service Content */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <h3
                    style={{
                      fontFamily: 'Cardo, serif',
                      fontSize: 'clamp(18px, 3vw, 22px)',
                      fontWeight: '400',
                      color: '#000000',
                      margin: '0',
                      lineHeight: '1.3'
                    }}
                  >
                    {service.title}
                  </h3>

                  <p
                    style={{
                      fontFamily: 'Plus Jakarta Sans, sans-serif',
                      fontSize: 'clamp(11px, 2vw, 12px)',
                      color: '#7b7b7b',
                      margin: '0',
                      lineHeight: '1.5'
                    }}
                  >
                    {service.description}
                  </p>

                  <Link
                    to={service.href}
                    style={{
                      backgroundColor: '#000000',
                      color: '#FFFFFF',
                      fontFamily: 'Plus Jakarta Sans, sans-serif',
                      fontSize: 'clamp(14px, 2.5vw, 16px)',
                      padding: 'clamp(10px, 3vw, 12px) clamp(24px, 5vw, 36px)',
                      border: 'none',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease',
                      textDecoration: 'none',
                      display: 'inline-block',
                      width: 'fit-content',
                      marginTop: '8px',
                      textAlign: 'center'
                    }}
                  >
                    Read More
                  </Link>
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </section>
  )
}

export default MembershipServicesSection